import f1 from "../../images/preview/icon/1.svg";
import f2 from "../../images/preview/icon/2.svg";
import f3 from "../../images/preview/icon/3.svg";
import f4 from "../../images/preview/icon/4.svg";
import f5 from "../../images/preview/icon/5.svg";
import f6 from "../../images/preview/icon/6.svg";

import tshape from "../../images/preview/title-2.png";

const features = [
  {
    icon: f1,
    title: "Hand-crafted Design",
    desc: "Bohu brings a brand new design for Wedding.",
  },
  {
    icon: f2,
    title: "Fully Responsive",
    desc: "We create fully responsive template for you.",
  },
  {
    icon: f3,
    title: "Lifetime License",
    desc: "We are providing you the lifetime license.",
  },
  {
    icon: f4,
    title: "Top-Notch Support",
    desc: "We guarantee the best possible fastest support.",
  },
  {
    icon: f5,
    title: "Free Updates",
    desc: "We mainly focuse on our client & buyers demands.",
  },
  {
    icon: f6,
    title: "RSVP Forms",
    desc: "Bohu brings an RSVP form for Wedding.",
  },
];

const FeaturesSection = () => {
  return (
    <section id="features" className="wpo-features-section section-padding">
      <div className="container">
        
        {/* Title Section */}
        <div className="row justify-content-center">
          <div className="col col-lg-6">
            <div className="preview-section-title">
              <div className="wow fadeInDown" data-wow-duration="1800ms">
                <i>
                  <img src={tshape} alt="" />
                </i>
              </div>
              <h2 className="poort-text poort-in-right">Amazing Features</h2>
              <p className="poort-text poort-in-right">
                We Happily Prepared 09 Homes for Your Big Day. Pick One of Our
                Beautiful Homepages to Start Your Dreamy Wedding Website!
              </p>
            </div>
          </div>
        </div>

        {/* Feature List */}
        <div className="wpo-features-wrapper">
          <div className="row">
            {features.map((item, index) => (
              <div className="col-lg-4 col-md-6 col-12" key={index}>
                <div
                  className="wpo-features-item wow fadeInUp"
                  data-wow-duration={`${1000 + index * 200}ms`}
                >
                  <div className="wpo-features-icon">
                    <div className="icon">
                      <i>
                        <img src={item.icon} alt={item.title} />
                      </i>
                    </div>
                  </div>
                  <div className="wpo-features-text">
                    <h2>{item.title}</h2>
                    <p>{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default FeaturesSection;
